export class ReviewFileCommentDbDto {
    public _id: string;
    public reviewId: string;
    public fileName: string;
    public lineNumber: number;
    public isError: boolean;
    public text: string;
}

